import React from 'react';
import { Hero } from './components/Hero';
import { Symptoms } from './components/Symptoms';
import { Testimonials } from './components/Testimonials';
import { Solution } from './components/Solution';
import { Modules } from './components/Modules';
import { FAQGuarantee } from './components/FAQGuarantee';
import { Footer } from './components/Footer';
import { StickyCTA } from './components/StickyCTA';
export function App() {
  return <div className="min-h-screen bg-cream flex flex-col font-sans text-teal" data-id="element-0">
      <main className="flex-grow" data-id="element-1">
        <Hero data-id="element-2" />
        <Symptoms data-id="element-3" />
        <Testimonials data-id="element-4" />
        <Solution data-id="element-5" />
        <Modules data-id="element-6" />
        <FAQGuarantee data-id="element-7" />
      </main>
      <Footer data-id="element-8" />
      <StickyCTA data-id="element-9" />
    </div>;
}